<footer class="footer">
  <div class="container">
    <div class="row row-grid align-items-center">
      <div class="col-lg-6">
        <h3 class="text-primary font-weight-light mb-2">
          Thank you for supporting us!
        </h3>
        <h4 class="mb-0 font-weight-light">
          Let's get in touch on any of these platforms.
        </h4>
      </div>
      <div class="col-lg-6 text-lg-center btn-wrapper">
        <a
          href="javascript:void(0)"
          class="btn btn-neutral btn-icon-only btn-twitter btn-round btn-lg"
          ngbTooltip="Follow us"
        >
          <i class="fa fa-twitter"></i>
        </a>
        <a
          href="javascript:void(0)"
          class="btn btn-neutral btn-icon-only btn-facebook btn-round btn-lg"
          ngbTooltip="Like us"
        >
          <i class="fa fa-facebook-square"></i>
        </a>
        <a
          href="javascript:void(0)"
          class="btn btn-neutral btn-icon-only btn-insta btn-lg btn-round instagram"
          ngbTooltip="Follow us"
        >
          <i class="fa fa-instagram"></i>
        </a>
        <a
          href="javascript:void(0)"
          class="btn btn-neutral btn-icon-only btn-github btn-round btn-lg"
          ngbTooltip="Follow us"
        >
          <i class="fa fa-linkedin"></i>
        </a>
      </div>
    </div>
    <hr />
    <div class="row align-items-center justify-content-md-between">
      <div class="col-md-12">
        <div class="copyright text-center">
          &copy; {{ test | date: "yyyy" }}
          <a href="#" target="_blank">Powered By: ITE infotech pvt ltd </a>
        </div>
      </div>
    </div>
  </div>
</footer>
